import { createSlice } from "@reduxjs/toolkit";

export const mockDeviceAccount = {
  username: 'admin',
  password: 'password',
}

export const deviceAccountSlice = createSlice({
  name: "onPremDeviceAccount",
  initialState: {
    resource: "/orgs/:orgId/sites/:siteId/settings/deviceAccount",
    data: { ...mockDeviceAccount, }
  },
});

export default deviceAccountSlice.reducer;
